import React from 'react';
import StackView from '@components/StackView';
import Notification from '@components/Notification';
import NotificationContainer from '@components/NotificationContainer';
import MinifiedBridgeTransactionListItem from './MinifiedBridgeTransactionListItem';
import useSendTransactionContext from '@hooks/useSendTransactionContext';

function MinifiedBridgeTransactionList() {
  const { bridgeTxNotifications, hideBridgeTxNotification } =
    useSendTransactionContext();

  return (
    <NotificationContainer>
      <StackView spacing={3} direction="vertical">
        {bridgeTxNotifications
          .filter(({ isHidden }) => !isHidden)
          .map(({ bridgeTx: { id, depositTx, transferTx } }, index) => {
            return (
              <Notification key={depositTx.hash}>
                <MinifiedBridgeTransactionListItem
                  depositTxnHash={depositTx.hash || ''}
                  transferTxnHash={transferTx.hash || ''}
                  depositStatus={depositTx.status}
                  transferStatus={transferTx.status}
                  network={depositTx.network}
                  index={index}
                  onCloseNotification={() => hideBridgeTxNotification(id)}
                  chain={depositTx.chain}
                />
              </Notification>
            );
          })}
      </StackView>
    </NotificationContainer>
  );
}

export default MinifiedBridgeTransactionList;
